import React, { useEffect, useState } from "react";
import { Col, Row, Form, Input, Modal, Select, theme, Tag } from "antd";
import { URL_SALE } from "../../constants/urls";
import { PATCH, POST } from "../../frameworks/HttpClient";
import useDropdownItem from "../../common/useDropdownItem";
import { DATE_FORMAT, PRODUCT_TYPE } from "../../constants/string";
import CustomDatePicker from "../../common/CustomDatePicker";
import ErrorMessages from "../../common/ErrorMessages";
import { useParams } from "react-router-dom";
import _ from "lodash";

export default function DeliveryOrderModal(props) {
  const params = useParams();
  const { open, onClose, target, onUpdate, saleOrder } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = React.useState(false);
  const [errorMessages , setErrorMessages] = useState(null);
  const isCreate = target === 'add'

  const [debouncedDeliver, setDebouncedDeliver] =  React.useState('')
  const [debouncedLocation, setDebouncedLocation] =  React.useState('')
  const [debouncedShipping, setDebouncedShipping] =  React.useState('')

  const destinedOptions = useDropdownItem({manual: true, url: URL_SALE.DELIVERY_ADDRESS, label: "address", value: "id", pagination: true, params: { page_size: 999, buyer: _.get(saleOrder, 'buyer', null) } });
  const deliverOptions = useDropdownItem({manual: true, url: URL_SALE.SALE_DELIVER, label: "name", value: "id", pagination: true, params: { page_size: 999, name : debouncedDeliver } });
  const locationOptions = useDropdownItem({manual: true, url: URL_SALE.SALE_LOCATION, label: "name", value: "id", pagination: true, params: { page_size: 999, name : debouncedLocation } });
  const shippingOptions = useDropdownItem({manual: true, url: URL_SALE.SALE_SHIPPING, label: "name", value: "id", pagination: true, params: { page_size: 999, name : debouncedShipping } });

  const debounceDeliver = React.useCallback(_.debounce((_searchVal) => { setDebouncedDeliver(_searchVal) }, 800), []);
  const debounceLocation = React.useCallback(_.debounce((_searchVal) => { setDebouncedLocation(_searchVal) }, 800), []);
  const debounceShipping = React.useCallback(_.debounce((_searchVal) => { setDebouncedShipping(_searchVal) }, 800), []);

  const {
    token: { colorWarning ,colorSuccess },
  } = theme.useToken();

  
  const handleOK = async () => {
    setLoading(true)
    setErrorMessages(null);
    try {
      const data = await form.validateFields();
      data["sale_order"] = saleOrder.id;
      if(params.type === PRODUCT_TYPE.CONCENTRATE_LATEX){
        if (target?.id) {
          await PATCH(`${URL_SALE.DELIVERY_ORDER}${target.id}/`, data);
        } else {
          await POST(URL_SALE.DELIVERY_ORDER, data);
        }
      } else {
        if (target?.id) {
          await PATCH(`${URL_SALE.SKIM_DELIVERY_ORDER}${target.id}/`, data);
        } else {
          await POST(URL_SALE.SKIM_DELIVERY_ORDER, data);
        }
      }
      onUpdate();
    } catch (error) {
      setErrorMessages(error.errorMessages);
    } finally {
      setLoading(false)
    }
  };
  
  useEffect(() => {
    if(open){
      destinedOptions.fetchOptions();
      deliverOptions.fetchOptions();
      locationOptions.fetchOptions();
      shippingOptions.fetchOptions();
      if (!isCreate) {
        if (target) {
          form.setFieldsValue({...target});
        } else {
          form.resetFields();
        }
      }
    } else {
      form.resetFields();
    }
  }, [open]);

  React.useEffect(() => {
    if(open){
      deliverOptions.fetchOptions();
    }
  },[debouncedDeliver])

  React.useEffect(() => {
    if(open){
      locationOptions.fetchOptions();
    }
  },[debouncedLocation])

  React.useEffect(() => {
    if(open){
      shippingOptions.fetchOptions();
    }
  },[debouncedShipping])

  React.useEffect(() => {
    if(saleOrder && !target)
      form.setFieldValue('irl_no', _.get(saleOrder, 'order_no', null)) 
  },[open, saleOrder])
  return (
    <Modal
      open={open}
      onCancel={onClose}
      okText={isCreate ? "เพิ่ม" : "แก้ไข"}
      cancelText={"ยกเลิก"}
      title={"ใบส่งสินค้า"}
      width={800}
      onOk={handleOK}
      destroyOnClose
      okButtonProps={{
        style: { backgroundColor: isCreate ? colorSuccess : colorWarning },
        loading,
      }}
    >
      <ErrorMessages message={errorMessages}/>
      <Form
        form={form}
        style={{ margin: "auto" }}
        layout="vertical"
      >
        <Row gutter={16}>
        <Col span={6}>
          <CustomDatePicker
            label="วันที่"
            name="date"
            style={{ width: "100%" }}
            format={DATE_FORMAT}
            placeholder="วันที่"
          />
        </Col>

        <Col span={6}>
          <Form.Item
            label="Deliver No"
            name="delivery_no"
            // rules={[{ required: true, message : 'กรุณากรอกข้อมูล' }]}
          >
            <Input  style={{ width : '100%'}} placeholder="Deliver No" />
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item
            label="SERIAL ID"
            name="serial_id"
            rules={[{ required: true, message: 'กรุณากรอกข้อมูล' }]}
          >
            <Input style={{ width : '100%'}} placeholder="SERIAL ID"/>
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item
            label="SERIAL NO"
            name="serial_no"
          >
            <Input style={{ width : '100%'}} placeholder="SERIAL NO"/>
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item
            label={"IRL CONTRACT NO."}
            name="irl_no"
          >
            <Input style={{ width : '100%'}} placeholder="IRL CONTRACT NO."/>
          </Form.Item>
        </Col>

        <Col span={9}>
          <Form.Item
            label={"SEAL NO"}
            name="seal_no"
          >
            <Input style={{ width : '100%'}} placeholder="SEAL NO."/>
          </Form.Item>
        </Col>

        <Col span={9}>
          <Form.Item
            label={"TAX NO"}
            name="tax_no"
          >
            <Input  style={{ width : '100%'}} placeholder="TAX NO"/>
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item
            label={"Order No / Buyer No"}
            name="order_no"
          >
            <Input  style={{ width : '100%'}} placeholder="Order No. / Buyer No"/>
          </Form.Item>
        </Col>

        <Col span={9}>
          <Form.Item
            label={"ปลายทางส่งสินค้า"}
            name="destination"
          >
            <Select
              showSearch
              autoComplete="off"
              options={destinedOptions.options}
              style={{ width : '100%'}}
              placeholder="ปลายทางส่งสินค้า"
            />
          </Form.Item>
        </Col>

        <Col span={9}>
          <Form.Item
            label={"บริษัทขนส่ง"}
            name="deliver"
          >
            <Select
              showSearch
              placeholder="บริษัทขนส่ง"
              autoComplete="off"
              options={deliverOptions.options}
              filterOption={false}
              style={{ width : '100%'}}
              onSearch={debounceDeliver}
            />
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item
            label="CONTAINER NO"
            name="container_no"
          >
            <Input placeholder="CONTAINER NO" style={{ width : '100%'}} />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            label="DRIVER"
            name="driver"
          >
            <Input placeholder="DRIVER" style={{ width : '100%'}} />
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item
            label="Lorry No"
            name="license_plate"
          >
            <Input placeholder="Lorry No" style={{ width : '100%'}} />
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item
            label="Location"
            name="location"
          >
            <Select
              showSearch
              placeholder="Location"
              autoComplete="off"
              options={locationOptions.options}
              filterOption={false}
              onSearch={debounceLocation}
              style={{ width : '100%'}}
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            label="Survey / Shipping"
            name="shipping"
          >
            <Select
              showSearch
              placeholder="Survey / Shipping"
              autoComplete="off"
              options={shippingOptions.options}
              filterOption={false}
              onSearch={debounceShipping}
              style={{ width : '100%'}}
            />
          </Form.Item>
        </Col>

        <Col span={6}>
          <CustomDatePicker
            label="ETA Date"
            name="eta_date"
            placeholder="ETA Date"
            style={{ width: "100%" }}
            format={DATE_FORMAT}
          />
        </Col>

        {params.type === PRODUCT_TYPE.CONCENTRATE_LATEX && <Col span={6}>
          <Form.Item
            label="Bag No."
            name="bag_no"
          >
            <Input placeholder="Bag No." style={{ width : '100%'}} />
          </Form.Item>
        </Col>}

        {params.type === PRODUCT_TYPE.SKIM && <Col span={8}>
          <Form.Item
            label="น้ำหนักชั่ง"
            name="weight"
          >
            <Input placeholder="น้ำหนักชั่ง" style={{ width : '100%'}} />
          </Form.Item>
        </Col>}

        {params.type === PRODUCT_TYPE.SKIM && target && target.net_weight && <Col span={8}>
          <Form.Item
            label="น้ำหนักที่คำนวณได้"
            name="loaded_weight"
          >
            {Number(target.net_weight ? target.net_weight : 0).toFixed(2)} kg.
          </Form.Item>
        </Col>}

        <Col span={24}>
          <Form.Item
            label="หมายเหตุ"
            name="note"
          >
            <Input.TextArea placeholder="หมายเหตุ" style={{ width : '100%'}} />
          </Form.Item>
        </Col>

        </Row>
      </Form>
    </Modal>
  );
}
